<ng-container *transloco="let t; read: 'partials.agenda.exercise_single'">
  <div class="slot-list single">
    <ng-container *ngFor="let slot of container.slots">
      <app-agenda-exercise-slot
        [slot]="slot"
        [candidate]="candidate"
        [container]="container"
      ></app-agenda-exercise-slot>
    </ng-container>
  </div>
</ng-container>
